import { render, staticRenderFns } from "./pictures.vue?vue&type=template&id=f5f06730&scoped=true&"
import script from "./pictures.vue?vue&type=script&lang=ts&"
export * from "./pictures.vue?vue&type=script&lang=ts&"
import style0 from "./pictures.vue?vue&type=style&index=0&id=f5f06730&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f06730",
  null
  
)

export default component.exports